/**
 * Page Addresses
 * 
 * @module page-address
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'page-address';

if (!customElements.get(customElements.component)) {

    class pageAddress extends HTMLElement {

        constructor() {

            super();

            this.activateMenu();
            this.toggleNewAddress();
            this.toggleEditAddress();
            this.modalDeleteAddress();
        }

        /**
         *  Init New Address Form toggle
         * 
         * @return {undefined}
        */
        toggleNewAddress() {
            document.querySelectorAll('[data-address-new-toggle]').forEach(button => {
                button.addEventListener('click', () => {

                    let newAddressForm = document.querySelector('[data-address-new-form]');
                    let newAddressButton = document.querySelector('[data-address-new-btn]');

                    newAddressForm.classList.toggle('hidden');
                    newAddressButton.focus();
                });
            });
        }

        /**
         *  Init Edit Address Form toggle
         * 
         * @return {undefined}
        */
        toggleEditAddress() {

            document.querySelectorAll('[data-address-edit-toggle]').forEach(button => {
                button.addEventListener('click', event => {

                    let formId = event.target.dataset.formId;
                    let editAddress = document.querySelector(`[data-edit-address-form="${formId}"]`);
                    let editButton = document.querySelector(`[data-address-edit-toggle][data-form-id="${formId}"]`);

                    editAddress.classList.toggle('hidden');
                    editButton.focus();
                });
            });

        }

        /**
         *  Init Modal Delete Address
         * 
         * @return {undefined}
        */
        modalDeleteAddress()  {

            document.querySelectorAll('[data-address-delete-btn]').forEach(button => {
                button.addEventListener('click', event => {

                    const confirmMessage = event.target.getAttribute('data-confirm-message');

                    if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                        event.preventDefault();
                    }

                });
            });

        }

        /**
         * Check the current URL and Add a class to the current li
         * 
         * @return {undefined}
         */
         activateMenu(){
            var hash = window.location.hash;
            const element = document.querySelector(`[data-account-sidebar-item="${hash}"]`)
            if(element) {
                element.classList.add('active')
            }
        }
    }

    customElements.define(customElements.component, pageAddress);
}
